import React from 'react'
import { Container } from 'reactstrap'
import '../../css/PopOverController.css'

class PopOverController extends React.Component{

    render() {
        if (!this.props.child) {
            return <></>
        }

        return (
            <>
            <div style={{'width': '100%', 'height': '100%'}}>
            </div>
            <Container className='outermodal'>
                <Container className='center'
                    style={{
                        'width': '600px',
                        'height': '90%',
                        'maxHeight': '600px',
                        'minHeight': '200px',
                    }} >
                <button
                    onClick={(e) => this.props.closeModal()}
                    type="button" class="close" aria-label="Close"
                    style={{
                        'position': 'absolute',
                        'margin': '0px',
                        'padding': '0px',
                        'top': '0px',
                        'right': '10px',
                        'border': 'none',
                        'backgroundColor': '#F000',
                        'fontSize': '1.5rem',
                        'fontWeight': '700',
                        'color': '#7F7F7F',
                    }}
                    ><span aria-hidden="true">&times;</span>
                </button>
                    {this.props.child}
                </Container>
            </Container>
            </>
        )
    }
}

export { PopOverController }
